import axiosInstance from "../../translator";
import { headerNotification as notification } from "../../constants/apis/apiEndpoints";

export const fetchUserNotificationList = async (urlParams) => {
  return axiosInstance
    .get(`${notification?.userNotification}${urlParams}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const userNotificationUpdateReadStatus = async (payload) => {
  const url = `${notification?.userNotification}/${payload?.markAll ? notification?.markAll : payload?.id}`;
  if (payload?.markAll) {
    return axiosInstance
      .post(url, !payload?.markAll && payload?.data)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error;
      });
  } else {
    return axiosInstance
      .patch(url, !payload?.markAll && payload?.data)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error;
      });
  }
};
